<template>
  <div>
    <DxPopup
      :visible="popupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      :show-title="true"
      :width="400"
      :height="150"
      title="New Version Available"
      @hidden="popupHidden"
      :showCloseButton="false"
      :wrapperAttr="{ class: 'gc-popup-version-update' }"
    >
      <div class="main">
        <div class="content">
          <span>
            A new version of GCORPcx is available. Click on the Update button to
            refresh now.
          </span>
        </div>
        <div class="footer">
          <DxButton
            text="Remind Me Later"
            type="normal"
            styling-mode="contained"
            @click="popupHidden(false)"
          />
          <DxButton
            text="Update"
            type="success"
            styling-mode="contained"
            @click="popupHidden(true)"
          />
        </div>
      </div>
    </DxPopup>
  </div>
</template>

<script>
import BaseViewMixin from "../v1/_mixins/base.view";

export default {
  props: {
    setVisible: Boolean,
    callBack: {
      type: Function,
      default: function () {},
    },
  },
  mixins: [BaseViewMixin],
  data() {
    return {};
  },
  async created() {
    const broadcastChannel = new BroadcastChannel("session-channel");
    broadcastChannel.addEventListener("message", (event) => {
      if (
        event.data &&
        event.data.action === "version_interval" &&
        this.setVisible == true
      ) {
        this.callBack(false);
      }
    });
  },
  computed: {
    popupVisible() {
      return this.setVisible ? true : false;
    },
  },
  watch: {},
  methods: {
    popupHidden(value) {
      this.callBack(value);
    },
  },
};
</script>

<style lang="scss">
.gc-popup-version-update {
  .main {
    // padding: 12px;
  }

  .footer {
    display: flex;
    justify-content: flex-end;

    .dx-button:first-child {
      margin-right: 5px;
    }
  }
}
</style>
